<template>
  <div id="app">
    <CommonHeader />
    <CommonNav />
    <router-view />
    <CommonBottom />
    <CommonFooter />
  </div>
</template>
<script>
import CommonHeader from "@/components/CommonHeader.vue";
import CommonNav from "@/components/CommonNav.vue";
import CommonFooter from "@/components/CommonFooter.vue";
import CommonBottom from "@/components/CommonBottom.vue";

export default {
  name: "Home",
  data() {
    return {
      routeName: ["home", "plan"],
    };
  },
  components: {
    CommonHeader,
    CommonNav,
    CommonFooter,
    CommonBottom,
  },
  watch: {
    // 全局监听路由
    $route(to) {
      var selectItem = "home";
      switch (to.name) {
        case "Home":
          selectItem = "home";
          break;
        case "PlanContent":
          selectItem = "plan";
          break;
        case "ScholarshipApply":
          selectItem = "scholarship";
          break;
        case "ExternalSportsProgrammes":
          selectItem = "scholarship";
          break;
        case "ScholarshipArea":
          selectItem = "winning_student";
          break;
        case "CommonProblem":
          selectItem = "q_a";
          break;
        case "SupportPartners":
          selectItem = "donate";
          break;
      }
      this.resetSetItem("selectNav", selectItem);
    },
  },
  mounted() {
    // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
    window.onbeforeunload = function() {
      var storage = window.localStorage;
      // storage.removeItem('locale')
      storage.removeItem('firstCome')
    };
  },
};
</script>
<style lang="scss">

</style>
